import React from 'react';
import { useContext } from 'react';
import styled, { keyframes } from 'styled-components';
import { Context } from '../MunicipalNoticeBoard';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const LoadingContainer = styled.div`
    width: 100vw;
    height: 100vw;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${(props) => props.theme.backgroundContrastColor};
    font-size: 3em;
    padding-top: 20vh;
`;

const Spinner = styled.div`
    animation: ${rotate360} 1s linear infinite;
    transform: translateZ(0);

    border-top: 0.5vw solid ${(props) => props.theme.backgroundContrastColor};
    border-right: 0.5vw solid ${(props) => props.theme.backgroundContrastColor};
    border-bottom: 0.5vw solid ${(props) => props.theme.backgroundContrastColor};
    border-left: 1vw solid ${(props) => props.theme.backgroundContrastColor};
    background: transparent;
    width: 8vw;
    height: 8vw;
    border-radius: 50%;
    margin-top: 3vh;
`;

export default () => {
    const ctx = useContext(Context);

    console.log('ctx', ctx);

    return (
        <LoadingContainer>
            <div>Loading ...</div>
            <Spinner />
        </LoadingContainer>
    );
};
